import { render, staticRenderFns } from "./RegionSummaryCard.vue?vue&type=template&id=c4f558da&scoped=true&"
import script from "./RegionSummaryCard.vue?vue&type=script&lang=js&"
export * from "./RegionSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./RegionSummaryCard.vue?vue&type=style&index=0&id=c4f558da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f558da",
  null
  
)

export default component.exports